module.exports = __webpack_public_path__ + "static/media/tint-slash.5a83ab94.svg";